import { CHEMICALS } from '../../../constants';
import style from './MineralBadge.module.css';

export const MineralBadge = ({ id, overrideClass, overrideStyles, children }) => <div
  className={`${style.mineralBadge} ${style[id.toLowerCase()] ?? ""} ${overrideClass ?? ""}`}
  style={{ ...overrideStyles }}>
  {children || CHEMICALS[id.toUpperCase()].SYM}
</div>;
